(() => {
  const root = window.Shopify?.routes?.root || '/';
  const labels = JSON.parse(document.querySelector('#modern-labels')?.textContent || '{}');
  const catalog = JSON.parse(document.querySelector('#modern-catalog')?.textContent || '[]');
  const lang = document.documentElement.lang || 'es';
  const money = (cents, currency = window.Shopify?.currency?.active || 'USD') => new Intl.NumberFormat(lang, {style:'currency', currency}).format(cents / 100);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const cleanName = value => value.split('|').pop().replace(/Oversized T-Shirt|Oversized T-shirt| — Camiseta de corte amplio/gi, '').trim();
  const bag = document.querySelector('[data-bag-dialog]');
  const quick = document.querySelector('[data-quick-dialog]');
  const search = document.querySelector('[data-search-dialog]');
  let lastOpener = null;
  let pendingCart = false;
  const show = (dialog, opener) => {
    document.querySelectorAll('.modern-dialog[open]').forEach(item => item.close());
    lastOpener = opener || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('modern-modal-open');
    (dialog.querySelector('input:not([type=hidden])') || dialog.querySelector('[data-dialog-close]'))?.focus();
  };
  document.querySelectorAll('.modern-dialog').forEach(dialog => {
    dialog.querySelectorAll('[data-dialog-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('.modern-dialog[open]')) document.documentElement.classList.remove('modern-modal-open');
      if (lastOpener?.isConnected) lastOpener.focus();
    });
  });
  async function request(path, options = {}) {
    const response = await fetch(root + path, {credentials:'same-origin', ...options});
    let data;
    try { data = await response.json(); } catch { throw new Error(labels.error); }
    if (!response.ok) throw new Error(data.description || data.message || labels.error);
    return data;
  }
  const announce = message => { const target = document.querySelector('[data-modern-status]'); if (target) target.textContent = message; };
  function drawCart(cart) {
    document.querySelectorAll('.cart-count').forEach(node => node.textContent = cart.item_count);
    document.querySelectorAll('[data-cart-label-template]').forEach(node => node.setAttribute('aria-label', node.dataset.cartLabelTemplate.replace('__COUNT__', cart.item_count)));
    bag.querySelector('[data-bag-count]').textContent = `(${cart.item_count})`;
    bag.querySelector('[data-bag-empty]').hidden = cart.items.length > 0;
    bag.querySelector('[data-bag-summary]').hidden = cart.items.length === 0;
    bag.querySelector('[data-bag-total]').textContent = money(cart.total_price, cart.currency);
    bag.querySelector('[data-bag-items]').innerHTML = cart.items.map(item => `<article class="modern-bag-item"><a href="${escape(item.url)}"><img src="${escape(item.image || '')}" alt="${escape(item.product_title)}" width="100" height="110"></a><div><a href="${escape(item.url)}">${escape(cleanName(item.product_title))}</a><p>${escape(item.variant_title || '')}</p>${item.selling_plan_allocation ? `<p>${escape(item.selling_plan_allocation.selling_plan.name)}</p>` : ''}<div class="modern-bag-quantity"><button type="button" data-cart-key="${escape(item.key)}" data-cart-quantity="${item.quantity - 1}" aria-label="${escape(labels.decrease)} · ${escape(item.product_title)}">−</button><span>${item.quantity}</span><button type="button" data-cart-key="${escape(item.key)}" data-cart-quantity="${item.quantity + 1}" aria-label="${escape(labels.increase)} · ${escape(item.product_title)}">+</button></div></div><div class="modern-bag-item-end"><button type="button" data-cart-key="${escape(item.key)}" data-cart-quantity="0" aria-label="${escape(labels.remove)} · ${escape(item.product_title)}">×</button>${item.original_line_price !== item.final_line_price ? `<s>${money(item.original_line_price, cart.currency)}</s>` : ''}<span>${money(item.final_line_price, cart.currency)}</span></div></article>`).join('');
  }
  const setBagError = message => { const node = bag.querySelector('[data-bag-error]'); node.textContent = message || ''; node.hidden = !message; };
  async function openBag(opener) {
    show(bag, opener); setBagError('');
    bag.querySelector('[data-bag-items]').textContent = labels.loading;
    bag.querySelector('[data-bag-summary]').hidden = true;
    bag.querySelector('[data-bag-empty]').hidden = true;
    try { drawCart(await request('cart.js')); } catch (error) { bag.querySelector('[data-bag-items]').textContent = ''; setBagError(error.message); }
  }
  document.querySelectorAll('[data-bag-open]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); openBag(link); }));
  bag?.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-key]');
    if (!button || pendingCart) return;
    pendingCart = true; setBagError(''); bag.setAttribute('aria-busy','true');
    bag.querySelectorAll('[data-cart-key]').forEach(node => node.disabled = true);
    try {
      drawCart(await request('cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:button.dataset.cartKey, quantity:Number(button.dataset.cartQuantity)})}));
      announce(labels.added);
    } catch (error) { setBagError(error.message); }
    finally { pendingCart = false; bag.removeAttribute('aria-busy'); bag.querySelectorAll('[data-cart-key]').forEach(node => node.disabled = false); }
  });
  async function addForm(form, errorNode) {
    if (pendingCart) return;
    pendingCart = true;
    const buttons = [...form.querySelectorAll('[type=submit]')];
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy','true'); });
    errorNode.hidden = true;
    let added = false;
    try {
      await request('cart/add.js', {method:'POST', body:new FormData(form)});
      added = true; announce(labels.added);
      if (quick.open) quick.close();
      await openBag(buttons[0]);
    } catch (error) {
      errorNode.hidden = false;
      errorNode.textContent = error.message;
      if (added) setBagError(labels.added);
    } finally {
      pendingCart = false;
      buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
    }
  }
  document.querySelectorAll('[data-product-section]').forEach(section => {
    const form = section.querySelector('.product-form');
    const availability = section.querySelector('[data-product-availability]');
    const addButton = section.querySelector('[data-product-add]');
    form.addEventListener('submit', event => {
      if (event.submitter && event.submitter !== addButton) return;
      event.preventDefault();
      if (section.dataset.sizeChosen === 'false') {
        availability.textContent = section.dataset.messageSizeError;
        availability.hidden = false;
        section.querySelector('[data-size-options]')?.scrollIntoView({block:'center', behavior:'smooth'});
        section.querySelector('[data-size-variant]:not(:disabled)')?.focus();
        return;
      }
      if (!form.reportValidity() || addButton.disabled) return;
      addForm(form, availability);
    });
    section.querySelector('[data-mobile-add]')?.addEventListener('click', () => form.requestSubmit(addButton));
    section.querySelectorAll('[data-gallery-switch]').forEach(button => button.addEventListener('click', () => {
      const image = section.querySelector('[data-product-image]');
      image.removeAttribute('srcset'); image.src = button.dataset.gallerySwitch; image.alt = button.dataset.imageAlt;
      const trigger = section.querySelector('.product-gallery__hero [data-gallery-open]');
      trigger.dataset.largeSrc = button.dataset.largeSrc; trigger.dataset.imageAlt = button.dataset.imageAlt;
      section.querySelectorAll('[data-gallery-switch]').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
    }));
    const guide = section.querySelector('[data-size-guide]');
    const officialTables = guide?.querySelectorAll('[data-size-guide-unit]');
    if (!officialTables?.length) section.querySelectorAll('.product-size-guide td').forEach(cell => cell.dataset.cm = cell.textContent);
    if (guide?.querySelector('table')) {
      const toggle = document.createElement('div'); toggle.className = 'modern-unit-toggle';
      ['cm','in'].forEach(unit => {
        const button = document.createElement('button'); button.type='button'; button.textContent = unit === 'cm' ? 'cm' : 'in'; button.setAttribute('aria-pressed',String(unit === 'cm'));
        button.addEventListener('click', () => {
          if (officialTables?.length) {
            officialTables.forEach(table => table.hidden = table.dataset.sizeGuideUnit !== (unit === 'in' ? 'inches' : 'cm'));
          } else {
            guide.querySelectorAll('td[data-cm]').forEach(cell => cell.textContent = unit === 'cm' ? cell.dataset.cm : (Number(cell.dataset.cm)/2.54).toFixed(1));
            guide.querySelector('caption').textContent = guide.dataset.caption + ` (${unit})`;
          }
          toggle.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
        }); toggle.append(button);
      }); if (!officialTables?.length) guide.dataset.caption = guide.querySelector('caption').textContent.replace(/\(cm\)/i,''); guide.querySelector('summary').after(toggle);
    }
  });
  document.querySelectorAll('[data-quick-open]').forEach(link => link.addEventListener('click', async event => {
    event.preventDefault(); const old = link.getAttribute('aria-busy'); if (old) return;
    link.setAttribute('aria-busy','true');
    try {
      const product = await request(`products/${encodeURIComponent(link.dataset.productHandle)}.js`);
      if (product.requires_selling_plan) { location.href = link.href; return; }
      quick.querySelector('[data-quick-name]').textContent = cleanName(product.title);
      quick.querySelector('[data-quick-image]').src = product.featured_image;
      quick.querySelector('[data-quick-image]').alt = product.title;
      quick.querySelector('[data-quick-price]').textContent = money(product.price);
      quick.querySelector('[data-quick-link]').href = link.href;
      quick.querySelector('[data-quick-error]').hidden = true;
      const options = quick.querySelector('[data-quick-options]'); options.replaceChildren();
      product.variants.forEach(variant => {
        const label = document.createElement('label');
        const input = document.createElement('input'); input.type='radio'; input.name='id'; input.value=variant.id; input.required=true; input.disabled=!variant.available;
        const text = document.createElement('span'); text.textContent = variant.public_title || variant.title;
        input.addEventListener('change', () => { quick.querySelector('[data-quick-price]').textContent=money(variant.price); quick.querySelector('[data-quick-error]').hidden=true; });
        label.append(input,text); options.append(label);
      }); show(quick,link);
    } catch { location.href = link.href; } finally { link.removeAttribute('aria-busy'); }
  }));
  quick?.querySelector('form')?.addEventListener('submit', event => {
    event.preventDefault(); const error = quick.querySelector('[data-quick-error]');
    if (!event.target.querySelector('input:checked')) { error.hidden=false; error.textContent=labels.size_error; return; }
    addForm(event.target,error);
  });
  function drawSearch(value) {
    const query = value.toLocaleLowerCase(lang).trim();
    const matches = catalog.filter(item => `${item.title} ${item.tags.join(' ')}`.toLocaleLowerCase(lang).includes(query));
    search.querySelector('[data-search-results]').innerHTML = matches.length ? matches.map(item => `<a href="${escape(item.url)}"><img src="${escape(item.image)}" alt="" width="70" height="70"><span>${escape(cleanName(item.title))}</span><strong>${money(item.price)}</strong></a>`).join('') : `<p>${escape(labels.search_none)}</p>`;
  }
  document.querySelectorAll('[data-search-open]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); drawSearch(''); show(search,link); }));
  search?.querySelector('input[type=search]')?.addEventListener('input', event => drawSearch(event.target.value));
  document.querySelectorAll('[data-modern-catalog]').forEach(section => section.querySelectorAll('[data-catalog-filter]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    section.querySelectorAll('[data-catalog-filter]').forEach(item => item.setAttribute('aria-current',item === link ? 'page':'false'));
    let count=0; section.querySelectorAll('.product-card').forEach(card => { card.hidden=link.dataset.catalogFilter !== 'Todos' && card.dataset.series !== link.dataset.catalogFilter; if (!card.hidden) count++; });
    section.querySelector('[data-filter-count]').textContent = `${link.textContent}: ${count}`;
  })));
  document.addEventListener('keydown', event => { if ((event.ctrlKey || event.metaKey) && event.key === 'k') { event.preventDefault(); drawSearch(''); show(search); } });
})();
